module.exports = __webpack_public_path__ + "img/las-canadas__logo--white.381bb24d.svg";